module.exports = __webpack_public_path__ + "img/horizontal_3_5_9016.9c02d174.png";